
export const createUrlParams = (params) => {
    const urlParams = new URLSearchParams();

    // Add a params to the URLSearchParams object if it's not undefined or null
    for (const key in params) {
        if (params[key] === undefined){
            continue;
        }
        if (params[key] === null){
            continue;
        }
        if (params[key] === ""){
            continue;
        }
        if (Array.isArray(params[key]) && params[key].length === 0){
            continue;
        }

        if (key === "pageIndex") {
            urlParams.append("page_index", params[key]);
        }
        else if (key === "pageSize") {
            urlParams.append("page_size", params[key]);
        }
        else if (key === "orderBy") {
            urlParams.append("order_by", params[key]);
        }
        else {
            urlParams.append(key, params[key]);
        }
    }

    return urlParams;
}